"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const AdAnalyticsPlacementTypes_1 = require("../AdAnalyticsPlacementTypes");
const Project_1 = require("../Project");
const AdAnalyticsVideoIndex_1 = require("./AdAnalyticsVideoIndex");
class AdAnalyticsVideo {
    constructor({ adVideoId, analyzingState, title, project, platforms, medias, placements, impressions, clicks, currency, spend, mobileAppInstalls, conversions, conversionsKey, viewThroughConversions, cvr, ctr, cpc, cpm, cpa, cpaWithViewThroughConversions, duration, videoUrl, thumbnailImageUrl, adAnalyticsVideoIndex, }) {
        this.toJSON = () => ({
            adVideoId: this.adVideoId,
            analyzingState: this.analyzingState,
            title: this.title,
            project: this.project && this.project.toJSON(),
            platforms: this.platforms && this.platforms.toJSON(),
            medias: this.medias && this.medias.toJSON(),
            placements: this.placements && this.placements.toJSON(),
            impressions: this.impressions,
            clicks: this.clicks,
            currency: this.currency,
            spend: this.spend,
            mobileAppInstalls: this.mobileAppInstalls,
            conversions: this.conversions,
            conversionsKey: this.conversionsKey,
            viewThroughConversions: this.viewThroughConversions,
            cvr: this.cvr,
            ctr: this.ctr,
            cpc: this.cpc,
            cpm: this.cpm,
            cpa: this.cpa,
            cpaWithViewThroughConversions: this.cpaWithViewThroughConversions,
            duration: this.duration,
            videoUrl: this.videoUrl,
            thumbnailImageUrl: this.thumbnailImageUrl,
            adAnalyticsVideoIndex: this.adAnalyticsVideoIndex && this.adAnalyticsVideoIndex.toJSON(),
        });
        this.adVideoId = adVideoId;
        this.analyzingState = analyzingState;
        this.title = title;
        this.project = project;
        this.platforms = platforms;
        this.medias = medias;
        this.placements = placements;
        this.impressions = impressions;
        this.clicks = clicks;
        this.currency = currency;
        this.spend = spend;
        this.mobileAppInstalls = mobileAppInstalls;
        this.conversions = conversions;
        this.conversionsKey = conversionsKey;
        this.viewThroughConversions = viewThroughConversions;
        this.cvr = cvr;
        this.ctr = ctr;
        this.cpc = cpc;
        this.cpm = cpm;
        this.cpa = cpa;
        this.cpaWithViewThroughConversions = cpaWithViewThroughConversions;
        this.duration = duration;
        this.videoUrl = videoUrl;
        this.thumbnailImageUrl = thumbnailImageUrl;
        this.adAnalyticsVideoIndex = adAnalyticsVideoIndex;
    }
}
AdAnalyticsVideo.fromJSON = (json) => {
    const { adVideoId, analyzingState, title, project, platforms, medias, placements, impressions, clicks, currency, spend, mobileAppInstalls, conversions, conversionsKey, viewThroughConversions, cvr, ctr, cpc, cpm, cpa, cpaWithViewThroughConversions, duration, videoUrl, thumbnailImageUrl, adAnalyticsVideoIndex, } = Object.assign({}, json);
    if (typeof adVideoId !== 'string')
        throw new Error('.adVideoId must be a string');
    if (typeof title !== 'string')
        throw new Error('.title must be a string');
    if (typeof impressions !== 'number')
        throw new Error('.impressions must be a number');
    if (typeof clicks !== 'number')
        throw new Error('.clicks must be a number');
    if (typeof currency !== 'string')
        throw new Error('.currency must be a string');
    if (typeof spend !== 'number')
        throw new Error('.spend must be a number');
    if (mobileAppInstalls !== null && typeof mobileAppInstalls !== 'number')
        throw new Error('.mobileAppInstalls must be a number');
    if (typeof conversions !== 'number')
        throw new Error('.conversions must be a number');
    if (conversionsKey !== null && typeof conversionsKey !== 'string')
        throw new Error('.conversionsKey must be a string');
    if (typeof viewThroughConversions !== 'number')
        throw new Error('.viewThroughConversions must be a number');
    if (typeof cvr !== 'number')
        throw new Error('.cvr must be a number');
    if (ctr !== null && typeof ctr !== 'number')
        throw new Error('.ctr must be a number');
    if (cpc !== null && typeof cpc !== 'number')
        throw new Error('.cpc must be a number');
    if (cpm !== null && typeof cpm !== 'number')
        throw new Error('.cpm must be a number');
    if (cpa !== null && typeof cpa !== 'number')
        throw new Error('.cpa must be a number');
    if (cpaWithViewThroughConversions !== null && typeof cpaWithViewThroughConversions !== 'number')
        throw new Error('.cpaWithViewThroughConversions must be a number');
    if (typeof duration !== 'number')
        throw new Error('.duration must be a number');
    if (videoUrl !== undefined && typeof videoUrl !== 'string')
        throw new Error('.videoUrl must be a string');
    if (typeof thumbnailImageUrl !== 'string')
        throw new Error('.thumbnailImageUrl must be a string');
    if (!Array.isArray(platforms))
        throw new Error('.platforms must be an array');
    if (!Array.isArray(medias))
        throw new Error('.medias must be an array');
    if (!Array.isArray(placements))
        throw new Error('.placements must be an array');
    const _project = project ? Project_1.default.fromJSON(project) : null;
    const _platforms = immutable_1.List(platforms).map((platform) => AdAnalyticsPlacementTypes_1.AdAnalyticsPlatform.fromJSON(platform));
    const _medias = immutable_1.List(medias).map((media) => AdAnalyticsPlacementTypes_1.AdAnalyticsMedia.fromJSON(media));
    const _placements = immutable_1.List(placements).map((placement) => AdAnalyticsPlacementTypes_1.AdAnalyticsPlacement.fromJSON(placement));
    const _adAnalyticsVideoIndex = adAnalyticsVideoIndex ? AdAnalyticsVideoIndex_1.default.fromJSON(adAnalyticsVideoIndex) : null;
    return new AdAnalyticsVideo({
        adVideoId,
        analyzingState,
        title,
        project: _project,
        platforms: _platforms,
        medias: _medias,
        placements: _placements,
        impressions,
        clicks,
        currency,
        spend,
        mobileAppInstalls,
        conversions,
        conversionsKey,
        viewThroughConversions,
        cvr,
        ctr,
        cpc,
        cpm,
        cpa,
        cpaWithViewThroughConversions,
        duration,
        videoUrl,
        thumbnailImageUrl,
        adAnalyticsVideoIndex: _adAnalyticsVideoIndex,
    });
};
exports.default = AdAnalyticsVideo;
